import React from 'react';
import { PlayerAvatar } from './PlayerAvatar';

export const MinPlayerRow = React.memo(({ playerPos, onSelect, variant = 'compact' }) => {
  const { player, eligibility, is_captain, jersey_number } = playerPos;
  const isInactive = !eligibility.eligible || eligibility.isExpelled || eligibility.isSubstituted;
  const hasYellowCard = eligibility.yellowCards > 0;
  const fullName = `${player?.first_name || ''} ${player?.last_name || ''}`.trim() || 'Unknown';

  const avatarSize = variant === 'hybrid' ? 56 : 40;

  return (
    <div
      onClick={isInactive ? undefined : () => onSelect(playerPos)}
      className={`
        flex items-center gap-3 p-2 rounded-lg
        transition-all
        ${isInactive
          ? 'opacity-30 cursor-default'
          : 'cursor-pointer hover:bg-white/5 active:bg-white/10 active:scale-[0.98]'
        }
      `}
    >
      {/* Avatar */}
      <PlayerAvatar player={player} jerseyNumber={jersey_number} size={avatarSize} />

      {/* Info */}
      <div className="flex-1 min-w-0">
        <div className={`text-sm font-medium text-white truncate ${isInactive ? 'line-through' : ''}`}>
          {fullName}
        </div>
        <div className="flex items-center gap-2 mt-0.5">
          <span className="text-xs text-gray-400 font-mono">#{jersey_number}</span>
          {is_captain && (
            <span className="px-1.5 py-0 bg-amber-600 text-white text-[10px] font-bold rounded">C</span>
          )}
        </div>
      </div>

      {/* Status badges */}
      <div className="flex items-center gap-1.5 flex-shrink-0">
        {hasYellowCard && !isInactive && (
          <div className="w-3 h-4 bg-yellow-400 rounded-sm" />
        )}
        {eligibility.isExpelled && (
          <div className="px-2 py-0.5 bg-red-900/50 text-red-400 text-[10px] font-bold rounded">
            OUT
          </div>
        )}
        {eligibility.isSubstituted && (
          <div className="px-2 py-0.5 bg-blue-900/50 text-blue-400 text-[10px] font-bold rounded">
            SUB
          </div>
        )}
        {!isInactive && (
          <svg className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        )}
      </div>
    </div>
  );
});

MinPlayerRow.displayName = 'MinPlayerRow';
